module.exports = __webpack_public_path__ + "static/media/hengshan_plant.ee7cb0c6.png";